export class AppError extends Error {
  constructor(readonly code: string, readonly message: string, readonly cause?: string | Error) {
    super(`${code}: ${message}`);
  }
}
